import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30a27e36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-4 p-md-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian tìm kiếm: ", -1))
const _hoisted_5 = { class: "p-field p-col-4 p-sm p-md-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "donViBC" }, "Đơn vị báo cáo", -1))
const _hoisted_7 = { class: "p-field p-col-4 p-sm p-md-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "taiThongTin" }, " Tải dữ liệu ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-sm-12 p-md-12" }, null, -1))
const _hoisted_10 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_11 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_12 = { class: "p-input-icon-left" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Không có danh sách nhân viên. ")
const _hoisted_16 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_17 = { id: "loading" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Đang xử lý xuất thông tin, vui lòng chờ ...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Panel, { header: "Tải thông tin báo cáo sự cố y khoa" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_Calendar, {
                id: "date",
                modelValue: $setup.date,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.date) = $event)),
                selectionMode: "range",
                dateFormat: "dd/mm/yy",
                showButtonBar: true,
                showIcon: true,
                manualInput: false,
                monthNavigator: true,
                yearNavigator: true,
                yearRange: "2000:2100",
                onClearClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.clearCalendar()))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_Dropdown, {
                id: "donViBC",
                filter: true,
                showClear: true,
                modelValue: $setup.selectTeam,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectTeam) = $event)),
                options: $setup.teams,
                optionLabel: "name",
                optionValue: "code",
                placeholder: "Vui lòng chọn đơn vị",
                style: {"text-align":"center"}
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Button, {
                id: "taiThongTin",
                label: "Xử lý",
                icon: "pi pi-spinner",
                iconPos: "left",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.loadData())),
                style: {"align-items":"center"},
                disabled: !$setup.valid()
              }, null, 8, ["disabled"])
            ]),
            _hoisted_9
          ])
        ])
      ]),
      _: 1
    }),
    ($setup.listMedical.length)
      ? (_openBlock(), _createBlock(_component_Panel, {
          key: 0,
          header: "Thông tin"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_DataTable, {
                loading: _ctx.isLoading,
                value: $setup.listMedical,
                paginator: true,
                stripedRows: "",
                filters: $setup.filters,
                "onUpdate:filters": _cache[7] || (_cache[7] = ($event: any) => (($setup.filters) = $event)),
                rows: 10,
                rowsPerPageOptions: [10,25,50],
                rowHover: true,
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                globalFilterFields: ['so_bc','donvi_bc'],
                columnResizeMode: "fit | expand",
                currentPageReportTemplate: "Có tất cả {totalRecords} báo cáo"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Button, {
                      type: "button",
                      icon: "pi pi-filter-slash",
                      label: "Xoá",
                      class: "p-button-outlined",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.clearFilter())),
                      style: {"width":"6em"}
                    }),
                    _createElementVNode("span", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_InputText, {
                        modelValue: $setup.filters['global'].value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.filters['global'].value) = $event)),
                        placeholder: "Tìm kiếm ..."
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                paginatorLeft: _withCtx(() => [
                  _createVNode(_component_Button, {
                    type: "button",
                    icon: "pi pi-refresh",
                    class: "p-button-text",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadList()))
                  })
                ]),
                empty: _withCtx(() => [
                  _hoisted_15
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "so_bc",
                    header: "Số báo cáo/ Mã số sự cố",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "donvi_bc",
                    header: "Đơn vị báo cáo",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "noi_xay_ra_sc",
                    header: "Nơi xãy ra sự cố",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "doi_tuong_xay_ra_sc",
                    header: "Đối tượng xãy ra sự cố",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "ngay_bc",
                    header: "Thời gian báo cáo",
                    sortable: ""
                  }, {
                    body: _withCtx(({data}) => [
                      _createTextVNode(_toDisplayString($setup.formatDateTime(data.ngay_bc)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "thoi_gian_xay_ra_sc",
                    header: "Thời gian xãy ra sự cố",
                    sortable: ""
                  }, {
                    body: _withCtx(({data}) => [
                      _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoi_gian_xay_ra_sc)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "symptoms",
                    header: "Tùy chọn"
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_Button, {
                        label: "Tải báo cáo",
                        type: "button",
                        icon: "pi pi-download",
                        align: "center",
                        onClick: ($event: any) => ($setup.exportFile(slotProps.data.medical_id))
                      }, null, 8, ["onClick"]),
                      _hoisted_14,
                      _createVNode(_component_Button, {
                        label: "In báo cáo",
                        type: "button",
                        icon: "pi pi-print",
                        align: "center",
                        onClick: ($event: any) => ($setup.printFile(slotProps.data.medical_id))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading", "value", "filters"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_Dialog, {
        header: "Đang xử ",
        visible: $setup.loadingBar,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (($setup.loadingBar) = $event)),
        closable: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_ProgressBar, {
              mode: "indeterminate",
              style: {"height":".3em"}
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}